/// <reference path="../../common/type-info.d.ts" />
import '../../common/type-info'
import * as mobx from 'mobx'
import $ from 'jquery'
import _ from 'lodash'
import * as extension from 'eyes-lib/src/prototype-ext'
import {Libs} from 'eyes-lib/es'
import {baseApp} from '../../modules/store'

const {registToGlobal} = Libs

/** 状態変更モード never:どこからでも | observed: 厳密モード | always: アクション指定 */
mobx.configure({enforceActions: 'always'})
// mobx.configure({enforceActions: 'never'})

/**
 * アプリケーションとして保持したい値や基本機能
 * @description pathInfoとミックスインさせてます
 */
const App = Object.freeze( baseApp )

/** APPはどこでも使えるようにGlobal変数に登録する */
registToGlobal('App', App)

/**
 * モデルオブジェクトを拡張する
 * @template T
 * @param {T} model
 */
const extendModel = function(model){
	return Object.seal( _.extend({
		/**
		 * 新しいインスタンスを生成する
		 */
		new: function(){
			/** newプロパティがないと型チェックですぐ怒られるので生やしておく */
			return _.merge({new: this.new}, model)
		}
	}, model ))
}

/**
 * DOM状態オブジェクト合成
 * @description DOM状態オブジェにextendModelのnewを混入させないため
 * @param {import('../../modules/store').SearchDomState} dom
 */
function domStateMerge(dom, ...stats) {
	_.each( stats, stat => Libs.deepUnset(stat, 'new') )

	mobx.runInAction( '状態オブジェクト合成', () =>
	{
		_.merge.apply(null, [dom].concat(stats) )

		/** tmp系はここで加工して入れ込む */
		_.each(dom, (ignore, key) => {
			if( key.startsWith('tmp_') )
			{
				const srcKey = key.substr(4)
				const srcVal = _.get(dom, srcKey )
				_.set( dom, key, srcVal )
			}
		} )
	})
}

/**
 * 
 */
const objKey = "mypageLoginData"

const agentObjKey = "mypageAgentData"


/**
* ログイン情報クラス
*/
const LoginInfo = extendModel({

	uniquKey:"",

	/**@type {import("./store").CustData} ログイン情報*/
	cust:null,

})

/**
 * 顧客情報クラス
 */
const CustData = extendModel({

	/** 顧客名コード */
	code:"",

    /** 顧客コード **/
    name:""
})


/**
 * 代理店情報クラス
 */
const AgentData = extendModel({

	/** 代理店コード **/
	agent_code:"",

	/** 代理店支店コード **/
	agentb_code:"",

	/** 代理店名 */
	agent_name:"",

    /** 代理店支店名 **/
    agentb_name:"",
})





/** jQuery.readyによる共通処理 */
$(()=>{
	/** ヘッダフッタがあればセッションストレージに保存して、なければセッションストレージから取得する */
	{
		/** @type {string} */
		let headercd = _.get( Libs.urlInfo().param, 'hcd', '' )
		const $header = $('#header')
		const $footer = $('#footer')
		let headerHtml = Libs.trim($header.html())
		let footerHtml = Libs.trim($footer.html())

		/** 空だったらセッションストレージから取得 */
		if( headerHtml )
		{
			App.permanentSession.setItem('header', {
				code: headercd,
				html: headerHtml
			})
		}
		else
		{
			const item = App.permanentSession.getItem('header')
			if ( item )
			{
				$header.html( _.get(item, 'html') )
				if ( !headercd ) headercd = _.get(item, 'code')
			}
		}
	
		/** 空だったらセッションストレージから取得 */
		if( footerHtml )
		{
			App.permanentSession.setItem('footer', {
				code: headercd,
				html: footerHtml
			})
		}
		else
		{
			const item = App.permanentSession.getItem('footer')
			if ( item )
			{
				$footer.html( _.get(item, 'html') )
				if ( !headercd ) headercd = _.get(item, 'code')
			}
		}

		/** App.data.headercdに保存 */
		if( headercd ) _.set(App.data, 'headercd', headercd)
	}
})

export {
	App,
	extendModel,
    domStateMerge,
	LoginInfo,
	CustData,
	AgentData,
	objKey,
	agentObjKey,
}